module.exports = __webpack_public_path__ + "static/media/home-bg.9cae5651.jpg";